import { useEffect, useRef } from 'react'
import { ChatMessage } from 'types/chat-message'

export const useScrollBottom = (messageStack: ChatMessage[]) => {
  const containerRef = useRef<HTMLDivElement>(null)
  useEffect(() => {
    const el = containerRef.current
    el?.scrollTo({ top: el.scrollHeight, behavior: 'smooth' })
  }, [messageStack])
  return containerRef
}
